module.exports = __webpack_public_path__ + "static/img/img.b3898593.png";